import React from "react";
import { HiOutlineSlash } from "react-icons/hi2";
import { useSelector } from "react-redux";

const NavBarSkeleton = () => {
  const { activeWorkspace } = useSelector((state) => state.app);
  
  return (
    <div
      className="fixed top-0 left-0 right-0 bg-white"
      style={{ zIndex: 40 }}
    >
      <nav className="flex flex-wrap items-center justify-between min-h-16 w-full border-b border-gray-200">
        {/* Left section - Logo */}
        <div className="flex items-center h-16 flex-1 min-w-0 max-w-full">
          <div className="h-16 pl-3 w-[60px] flex items-center justify-center flex-shrink-0">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/surveyappreact.firebasestorage.app/o/default%2Flogo_pb.svg?alt=media&token=e0035fbc-fa3e-4b6c-8ae5-81eac333c8e4"
              alt="Logo"
              className="h-8 w-auto"
            />
          </div>
          <div className="relative ml-1 min-w-0 flex-1">
            <div className="flex items-center space-x-2 text-sm font-normal">
              <div className="flex-shrink-0">
                <HiOutlineSlash size={18} className="text-gray-300" />
              </div>
              <span className="text-sm font-normal text-gray-900 truncate max-w-[220px] font-inter" title={activeWorkspace?.name || "All Forms"}>
                {activeWorkspace?.name || "All Forms"}
              </span>
            </div>
          </div>
        </div>

        {/* Right section - Profile area */}
        <div className="flex items-center h-16 px-2 md:px-4 gap-2 md:gap-3 flex-shrink-0">
          {/* Notification placeholder */}
          <div className="w-6 h-6 rounded-full bg-gray-100 animate-shimmer-subtle"></div>
          
          {/* Profile image placeholder */}
          <div className="w-9 h-9 rounded-full bg-gray-100 animate-shimmer-subtle"></div>
        </div>
      </nav>
    </div>
  );
};

export default NavBarSkeleton; 